document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const liveRegion = document.getElementById('NelaLiveRegion');

document.addEventListener('submit', (event) => {
  const searchForm = event.target.closest('[data-empty-search-url]');
  const searchInput = searchForm?.querySelector('input[name="q"]');
  if (searchForm && !searchInput?.value.trim()) {
    event.preventDefault();
    window.location.assign(searchForm.dataset.emptySearchUrl);
    return;
  }

  const withdrawalForm = event.target.closest('[data-withdrawal-form]');
  const timestamp = withdrawalForm?.querySelector('[data-withdrawal-timestamp]');
  if (timestamp) timestamp.value = new Date().toISOString();
});

document.addEventListener('click', (event) => {
  const lineFilterButton = event.target.closest('[data-line-filter]');
  if (lineFilterButton) {
    const selector = lineFilterButton.closest('[data-product-line-filter]');
    const selectedLine = lineFilterButton.dataset.lineFilter;
    const productItems = Array.from(document.querySelectorAll('[data-product-line]'));
    selector?.querySelectorAll('[data-line-filter]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === lineFilterButton));
    });
    productItems.forEach((item) => {
      item.hidden = selectedLine !== 'all' && item.dataset.productLine !== selectedLine;
    });
    const count = productItems.filter((item) => !item.hidden).length;
    const countElement = document.querySelector('[data-collection-count]');
    const countTemplate = countElement?.dataset.countTemplate;
    if (countElement && countTemplate) countElement.textContent = countTemplate.replace('COUNT_TOKEN', String(count));
    document.querySelector('.collection-results')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  const galleryThumbnail = event.target.closest('[data-gallery-thumbnail]');
  if (galleryThumbnail) {
    const gallery = galleryThumbnail.closest('[data-product-gallery]');
    const targetId = galleryThumbnail.getAttribute('aria-controls');
    gallery?.querySelectorAll('[data-gallery-slide]').forEach((slide) => {
      const isActive = slide.id === targetId;
      slide.hidden = !isActive;
      if (!isActive) {
        slide.querySelectorAll('video').forEach((video) => video.pause());
        slide.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
      }
    });
    gallery?.querySelectorAll('[data-gallery-thumbnail]').forEach((item) => {
      item.setAttribute('aria-current', String(item === galleryThumbnail));
    });
  }

  const catalogButton = event.target.closest('[data-catalog-toggle]');
  if (catalogButton) {
    const drawer = document.getElementById(catalogButton.getAttribute('aria-controls'));
    const expanded = catalogButton.getAttribute('aria-expanded') === 'true';
    catalogButton.setAttribute('aria-expanded', String(!expanded));
    drawer.hidden = expanded;
    document.body.classList.toggle('catalog-open', !expanded);
  }

  const catalogClose = event.target.closest('[data-catalog-close]');
  if (catalogClose) {
    const drawer = catalogClose.closest('[data-catalog-drawer]');
    const button = document.querySelector(`[aria-controls="${drawer?.id}"]`);
    if (drawer) drawer.hidden = true;
    button?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('catalog-open');
  }

  const sliderButton = event.target.closest('[data-slider-button]');
  if (sliderButton) {
    const slider = sliderButton.closest('.related-products')?.querySelector('[data-slider-track]');
    const direction = sliderButton.dataset.sliderButton === 'next' ? 1 : -1;
    slider?.scrollBy({ left: direction * slider.clientWidth * 0.82, behavior: 'smooth' });
  }

  const filterButton = event.target.closest('[data-filter-toggle]');
  if (filterButton) {
    const filters = document.getElementById(filterButton.getAttribute('aria-controls'));
    const expanded = filterButton.getAttribute('aria-expanded') === 'true';
    filterButton.setAttribute('aria-expanded', String(!expanded));
    filters?.classList.toggle('is-open', !expanded);
  }

  const filterClose = event.target.closest('[data-filter-close]');
  if (filterClose) {
    const filters = filterClose.closest('[data-collection-filters]');
    filters?.classList.remove('is-open');
    document.querySelector('[data-filter-toggle]')?.setAttribute('aria-expanded', 'false');
  }

  const menuButton = event.target.closest('[data-menu-toggle]');
  if (menuButton) {
    const menu = document.getElementById(menuButton.getAttribute('aria-controls'));
    const expanded = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!expanded));
    menu.hidden = expanded;
  }
});

document.addEventListener('keydown', (event) => {
  const thumbnail = event.target.closest('[data-gallery-thumbnail]');
  if (!thumbnail || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
  const thumbnails = Array.from(thumbnail.closest('[data-product-gallery]')?.querySelectorAll('[data-gallery-thumbnail]') || []);
  const direction = event.key === 'ArrowRight' ? 1 : -1;
  const next = thumbnails[(thumbnails.indexOf(thumbnail) + direction + thumbnails.length) % thumbnails.length];
  event.preventDefault();
  next?.focus();
  next?.click();
});

document.addEventListener('keydown', (event) => {
  const predictiveForm = event.target.closest('[data-predictive-search-form]');
  if (predictiveForm) {
    const results = predictiveForm.querySelector('[data-predictive-search-results]');
    const links = Array.from(results?.querySelectorAll('a[role="option"]') || []);
    if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && links.length) {
      event.preventDefault();
      const current = links.indexOf(document.activeElement);
      const next = event.key === 'ArrowDown'
        ? (current + 1) % links.length
        : (current <= 0 ? links.length - 1 : current - 1);
      links[next].focus();
      return;
    }
    if (event.key === 'Escape') {
      closePredictiveSearch(predictiveForm);
      predictiveForm.querySelector('[data-predictive-search-input]')?.focus();
      return;
    }
  }

  if (event.key !== 'Escape') return;
  const drawer = document.querySelector('[data-catalog-drawer]:not([hidden])');
  if (!drawer) return;
  drawer.hidden = true;
  document.querySelector(`[aria-controls="${drawer.id}"]`)?.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('catalog-open');
});

const predictiveSearchCache = new Map();

function closePredictiveSearch(form) {
  const input = form.querySelector('[data-predictive-search-input]');
  const results = form.querySelector('[data-predictive-search-results]');
  if (results) results.hidden = true;
  input?.setAttribute('aria-expanded', 'false');
}

function showPredictiveSearch(form, markup) {
  const input = form.querySelector('[data-predictive-search-input]');
  const results = form.querySelector('[data-predictive-search-results]');
  if (!results) return;
  results.innerHTML = markup;
  results.hidden = false;
  input?.setAttribute('aria-expanded', 'true');
  const count = results.querySelectorAll('.predictive-search__item').length;
  if (liveRegion) liveRegion.textContent = `${count} Suchvorschläge verfügbar.`;
}

document.querySelectorAll('[data-predictive-search-form]').forEach((form) => {
  const input = form.querySelector('[data-predictive-search-input]');
  const results = form.querySelector('[data-predictive-search-results]');
  if (!input || !results) return;

  let timer;
  let request;

  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    request?.abort();
    const term = input.value.trim();
    if (term.length < 2) {
      results.innerHTML = '';
      closePredictiveSearch(form);
      return;
    }

    timer = window.setTimeout(async () => {
      const cacheKey = term.toLocaleLowerCase();
      if (predictiveSearchCache.has(cacheKey)) {
        showPredictiveSearch(form, predictiveSearchCache.get(cacheKey));
        return;
      }

      request = new AbortController();
      form.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(form.dataset.predictiveSearchUrl, window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][fields]', 'title,product_type,variants.sku,variants.title,vendor');
        url.searchParams.set('resources[options][prefix]', 'last');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set('section_id', 'predictive-search');
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Predictive search request failed');
        const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = responseDocument.querySelector('[data-predictive-search-content]');
        if (!content || input.value.trim() !== term) return;
        const markup = content.outerHTML;
        predictiveSearchCache.set(cacheKey, markup);
        showPredictiveSearch(form, markup);
      } catch (error) {
        if (error.name !== 'AbortError') closePredictiveSearch(form);
      } finally {
        form.removeAttribute('aria-busy');
      }
    }, 220);
  });

  input.addEventListener('focus', () => {
    if (results.innerHTML.trim() && input.value.trim().length >= 2) {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
  });
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-predictive-search-form]').forEach((form) => {
    if (!form.contains(event.target)) closePredictiveSearch(form);
  });
});

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url) return;
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim()) {
          this.innerHTML = recommendations.innerHTML;
          this.classList.add('is-loaded');
        }
      })
      .catch(() => {});
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

document.addEventListener('change', (event) => {
  const collectionSwitcher = event.target.closest('[data-collection-switcher]');
  if (collectionSwitcher) {
    window.location.assign(collectionSwitcher.value);
    return;
  }

  const sortSelect = event.target.closest('[data-sort-select]');
  if (sortSelect) {
    const form = document.getElementById('CollectionFiltersForm');
    const input = form?.querySelector('[data-sort-input]');
    if (input) input.value = sortSelect.value;
    form?.requestSubmit();
    return;
  }

  const collectionFilter = event.target.closest('#CollectionFiltersForm input, #CollectionFiltersForm select');
  if (collectionFilter && collectionFilter.type !== 'number') {
    collectionFilter.form?.requestSubmit();
    return;
  }

  const variantSelect = event.target.closest('[data-variant-select]');
  if (!variantSelect) return;
  const form = variantSelect.closest('form');
  const option = variantSelect.options[variantSelect.selectedIndex];
  const button = form?.querySelector('[data-add-to-cart]');
  const price = document.querySelector('[data-product-price]');
  const productInfo = form?.closest('.product-info');
  const sku = productInfo?.querySelector('[data-product-sku]');
  const skuRow = productInfo?.querySelector('[data-product-sku-row]');
  const barcode = productInfo?.querySelector('[data-product-barcode]');
  const barcodeRow = productInfo?.querySelector('[data-product-barcode-row]');
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? button.dataset.addLabel : button.dataset.soldOutLabel;
  }
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (sku) sku.textContent = option.dataset.sku || '';
  if (skuRow) skuRow.hidden = !option.dataset.sku;
  if (barcode) barcode.textContent = option.dataset.barcode || '';
  if (barcodeRow) barcodeRow.hidden = !option.dataset.barcode;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantSelect.value);
  window.history.replaceState({}, '', url);
});

let collectionPriceTimer;
let cartUpdateTimer;
document.addEventListener('input', (event) => {
  const cartQuantity = event.target.closest('[data-cart-quantity]');
  if (cartQuantity) {
    window.clearTimeout(cartUpdateTimer);
    const quantity = Number(cartQuantity.value);
    if (!Number.isFinite(quantity) || quantity < 0) return;
    if (liveRegion) liveRegion.textContent = 'Warenkorb wird aktualisiert.';
    cartUpdateTimer = window.setTimeout(() => {
      const form = cartQuantity.closest('[data-cart-form]');
      const updateButton = form?.querySelector('[name="update"]');
      if (form && updateButton) form.requestSubmit(updateButton);
    }, 650);
    return;
  }

  const priceInput = event.target.closest('#CollectionFiltersForm input[type="number"]');
  if (!priceInput) return;
  window.clearTimeout(collectionPriceTimer);
  collectionPriceTimer = window.setTimeout(() => priceInput.form?.requestSubmit(), 650);
});

document.addEventListener('submit', (event) => {
  if (event.target.closest('[data-cart-form]')) window.clearTimeout(cartUpdateTimer);
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('#CollectionFiltersForm');
  if (!form) return;
  event.preventDefault();

  const params = new URLSearchParams();
  for (const [name, rawValue] of new FormData(form).entries()) {
    const value = String(rawValue).trim();
    if (!value) continue;
    if (name === 'sort_by') params.set(name, value);
    else params.append(name, value);
  }

  const query = params.toString();
  window.location.assign(`${form.action}${query ? `?${query}` : ''}`);
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form || !window.fetch) return;
  event.preventDefault();
  const button = form.querySelector('[data-add-to-cart]');
  button?.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Cart request failed');
    if (liveRegion) liveRegion.textContent = 'Produkt wurde in den Warenkorb gelegt.';
    window.location.href = window.Shopify.routes.root + 'cart';
  } catch (error) {
    form.submit();
  } finally {
    button?.removeAttribute('aria-busy');
  }
});
